



export function currentTime (){


const now = new Date();

// Get the current hour (0-23), minutes (0-59), and seconds (0-59)
const hour = now.getHours();
const minutes = now.getMinutes();
const seconds = now.getSeconds();

// Format the time string
const formattedTime = `${hour}:${minutes.toString().padStart(2, '0')};${seconds.toString().padStart(2, '0')}`;
return formattedTime

}


export function getCurrentDate(extraDays:number) {

  const today = new Date();
  today.setDate(today.getDate() + extraDays);
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = today.getFullYear();
  
  return `${year}/${month}/${day}`;
}